var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaidAidMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 291,
    viewBox: "0 0 247 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.335 151.623C244.335 186.547 216.015 214.827 181.091 214.827C146.166 214.827 117.887 186.547 117.887 151.623C117.887 116.699 146.166 88.3783 181.091 88.3783C216.015 88.3783 244.335 116.699 244.335 151.623Z",
    stroke: "#F8D3C9",
    strokeWidth: 4.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5624 30.3198C95.5624 30.3198 88.9584 19.4617 99.1277 9.90006C109.297 0.378937 108.001 6.09161 110.553 6.73985C113.106 7.3881 121.371 -2.78127 132.148 2.28316C142.965 7.3881 155.079 15.7748 146.814 30.3198C138.509 44.8649 137.901 42.3124 145.518 54.386C153.135 66.4596 143.614 81.0856 141.061 91.9032C138.509 102.68 131.54 107.785 125.827 109.041C120.074 110.297 89.6066 130.636 83.2457 131.932C76.8847 133.188 67.3637 136.997 61.0027 137.645C54.6418 138.253 44.4724 131.932 36.8555 138.901C29.2386 145.91 31.1429 154.175 33.6548 161.792C16.5168 140.198 19.677 127.476 26.0379 120.467C32.3989 113.498 34.9513 117.306 37.5038 112.201C40.0158 107.137 31.1429 99.5201 45.7284 88.7025C60.3545 77.9254 67.3637 93.1592 74.9806 89.3508C82.5975 85.5423 71.8203 64.5553 81.9492 48.6733C92.1186 32.7913 95.5624 30.3198 95.5624 30.3198Z",
    fill: "url(#paint0_linear_388_1778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7168 79.1818C66.7168 79.1818 72.4294 101.384 82.8014 113.417C87.5417 118.887 93.2139 122.25 99.7774 120.467C103.586 126.18 90.864 131.933 90.864 131.933C90.864 131.933 106.098 145.911 118.82 140.806C131.541 135.741 137.254 119.859 137.254 119.859C137.254 119.859 128.989 116.659 126.437 108.393C123.925 100.128 124.532 93.1596 124.532 93.1596C124.532 93.1596 137.902 78.5336 128.989 69.6607C120.076 60.7473 119.468 77.9258 119.468 77.9258L81.9506 59.4913L69.877 62.6515L66.7168 79.1818Z",
    fill: "#F8D3C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9076 138.902L90.215 126.828C90.215 126.828 96.6974 141.859 114.362 140.198C132.027 138.496 137.253 118.239 137.902 115.2L168.369 131.933L183.319 166.938L184.899 212.64L73.077 214.544L50.834 193.557L66.0678 150.975L62.9076 138.902Z",
    fill: "url(#paint1_linear_388_1778)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.224 141.94C185.224 141.94 200.782 150.975 210.951 171.313C221.121 191.652 231.29 215.151 216.056 223.416C200.782 231.681 162.049 182.739 158.848 170.665C155.688 158.592 172.218 140.481 185.224 141.94Z",
    fill: "#F8D3C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.014 174.19C175.014 174.19 185.264 151.987 195.879 150.529C195.879 150.529 190.126 144.006 187.817 143.357C185.548 142.709 176.108 150.042 176.108 150.042C176.108 150.042 175.379 151.987 174.123 154.337C172.826 156.687 169.342 161.792 169.342 161.792L175.014 174.19Z",
    fill: "#F8D3C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.459 214.543L1 211.99",
    stroke: "#350E28",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6031 241.729C76.6031 241.729 25.4321 246.307 24.7839 248.211C24.1356 250.116 26.6881 256.477 26.6881 256.477L3.79688 259.637L27.3363 280.624L20.9754 285.04C20.9754 285.04 30.4965 295.858 73.7264 288.241C116.916 280.624 136.606 270.454 141.063 259.637C145.52 248.819 139.807 246.915 139.807 246.915C139.807 246.915 147.87 232.491 132.069 233.059C116.268 233.585 76.6031 241.729 76.6031 241.729Z",
    fill: "url(#paint2_linear_388_1778)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.073 77.9256C120.073 77.9256 120.073 82.3417 116.913 85.5424C116.913 85.5424 118.817 77.2773 110.552 74.7248C102.287 72.1724 95.9258 78.5333 86.4046 77.9256C76.8835 77.2773 70.1985 64.4744 70.1985 64.4744C70.1985 64.4744 67.2004 79.9108 69.5097 86.2312C69.5097 86.2312 58.449 77.2773 60.3532 63.9072C62.2574 55.6826 64.8099 53.7784 66.7142 49.9294C68.6184 46.121 67.9702 40.4083 74.9793 38.5041C81.948 36.5998 82.5962 37.8558 82.5962 37.8558C82.5962 37.8558 86.4046 32.1432 92.1173 30.8872C97.8705 29.6312 98.4782 30.8872 101.031 29.6312C103.583 28.3347 104.434 27.0787 110.349 29.6312C116.264 32.1432 118.817 37.2481 122.018 38.5041C125.178 39.76 127.082 45.5132 128.338 49.9294C129.635 54.3861 130.242 52.4819 132.795 55.6826C135.347 58.8428 137.251 63.2995 134.699 68.3639C132.147 73.4689 132.147 73.4689 132.147 73.4689C132.147 73.4689 123.274 62.6512 120.073 77.9256Z",
    fill: "url(#paint3_linear_388_1778)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.716 140.197C66.716 140.197 47.6738 147.814 32.3995 172.569C17.1657 197.365 19.6776 208.79 24.7826 213.247C29.847 217.703 52.7382 228.521 61.0034 231.033C69.2685 233.585 96.5758 222.16 97.2241 217.055C97.8723 211.991 76.8854 191.004 67.3643 188.492C67.3643 188.492 77.5336 178.322 80.0456 168.153C82.5981 157.984 80.0456 136.348 66.716 140.197Z",
    fill: "#F8D3C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.42 142.71C181.091 145.343 172.258 170.017 160.306 174.19C143.573 150.327 137.861 136.349 153.094 124.275C165.006 114.876 194.42 142.71 194.42 142.71Z",
    fill: "url(#paint4_linear_388_1778)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.244 93.159C130.244 95.9546 127.975 98.2234 125.179 98.2234C122.384 98.2234 120.074 95.9546 120.074 93.159C120.074 90.3634 122.384 88.0541 125.179 88.0541C127.975 88.0541 130.244 90.3634 130.244 93.159Z",
    fill: "#350E28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.646 169.368V227.913C183.646 235.246 177.691 241.202 170.317 241.202H155.002C147.669 241.202 141.713 235.246 141.713 227.913V169.368C141.713 162.035 147.669 156.079 155.002 156.079H170.317C177.691 156.079 183.646 162.035 183.646 169.368ZM156.298 173.42C156.298 172.326 155.853 171.313 155.123 170.584C154.394 169.854 153.422 169.409 152.287 169.409C150.1 169.409 148.276 171.191 148.276 173.42V226.414C148.276 228.602 150.1 230.425 152.287 230.425C154.516 230.425 156.298 228.602 156.298 226.414V173.42Z",
    fill: "#56183E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.592 172.204V229.21C157.592 236.381 167.113 224.591 167.113 217.42V180.267C167.113 173.096 157.592 165.033 157.592 172.204Z",
    fill: "#350E28"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.936 158.389H162.294C161.078 158.389 160.146 157.417 160.146 156.242V149.314C160.146 148.139 161.078 147.166 162.294 147.166H171.936C173.152 147.166 174.124 148.139 174.124 149.314V156.242C174.124 157.417 173.152 158.389 171.936 158.389Z",
    fill: "#350E28"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8359 224.348C44.8359 224.348 76.4784 241.729 85.2703 243.998C94.0216 246.308 108.648 258.381 115.009 257.733C121.37 257.085 117.885 250.4 117.885 250.4C117.885 250.4 120.721 254.573 124.53 250.764C128.338 246.915 124.53 244.241 124.53 244.241C124.53 244.241 128.986 250.116 132.795 245.011C135.996 243.755 137.252 243.755 137.9 239.947C138.508 236.138 124.732 218.96 113.51 214.544C102.287 210.087 99.1266 210.087 99.1266 210.087L88.3089 193.557C88.3089 193.557 55.3294 201.781 44.8359 224.348Z",
    fill: "#350E28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.517 190.396C192.517 190.396 179.836 185.291 165.858 187.195C151.88 189.099 147.423 191.652 148.072 198.012C148.679 204.373 150.584 204.373 150.584 204.373C150.584 204.373 147.95 206.966 147.991 211.058C148.072 215.15 150.584 216.447 150.584 216.447C150.584 216.447 148.072 218.351 149.328 222.767C150.584 227.224 152.488 227.872 152.488 227.872C152.488 227.872 149.571 230.668 151.678 233.707C153.784 236.745 166.466 233.585 175.379 234.841C184.292 236.137 189.6 238.487 194.867 235.084C194.867 235.084 212.248 241.85 219.217 231.033C226.226 220.255 230.034 189.099 192.517 190.396Z",
    fill: "#350E28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.491 87.6891C103.261 89.6744 103.059 91.5786 102.086 91.9432C101.114 92.3079 99.6958 91.0519 98.926 89.0667C98.1967 87.1219 98.3588 85.2177 99.3312 84.853C100.304 84.4479 101.722 85.7444 102.491 87.6891Z",
    fill: "#350E28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0576 94.6991C84.8274 96.6438 84.6248 98.5481 83.6525 98.9532C82.6801 99.3179 81.2621 98.0214 80.4923 96.0766C79.763 94.0914 79.9251 92.1871 80.8974 91.8225C81.9103 91.4579 83.2878 92.7138 84.0576 94.6991Z",
    fill: "#350E28"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.082 89.0267C86.082 89.0267 86.7303 103.005 88.6345 103.653C90.5387 104.261 93.0507 103.653 93.0507 103.653",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5117 109.081C91.5117 109.081 93.2944 110.216 98.7235 108.555C104.112 106.894 111.85 97.6156 111.85 97.6156H111.081",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6992 81.3285C93.6992 81.3285 95.9276 78.5329 99.7765 77.9252",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7484 85.6639C81.7484 85.6639 78.5477 84.0433 74.8203 85.0157",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.086 74.725C127.086 74.725 123.926 79.1817 123.926 84.2461",
    stroke: "#350E28",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.341 82.3417C128.341 82.3417 126.923 79.7082 124.451 80.397",
    stroke: "#350E28",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100.385 120.466C100.385 120.466 111.526 118.562 117.887 107.541C116.915 119.007 109.946 125.247 100.385 125.085C101.681 122.248 100.385 120.466 100.385 120.466Z",
    fill: "#56183E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5782 150.327C49.5782 150.327 62.2596 170.058 74.9814 175.771",
    stroke: "#1D1D1B",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5547 245.173C88.5547 245.173 101.114 251.615 107.759 255.626C114.363 259.637 121.372 257.692 117.888 250.4C124.208 254.249 127.733 248.819 124.532 244.241C124.532 244.241 125.869 247.563 129.637 247.563C132.068 247.563 132.797 245.011 132.797 245.011C132.797 245.011 137.659 244.93 137.781 240.514C137.902 236.138 134.621 233.059 134.621 233.059",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.289 234.234C102.289 234.234 115.659 245.619 117.887 250.4",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.002 227.873C108.002 227.873 120.076 237.111 124.532 244.242",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.061 225.645C119.061 225.645 131.539 235.49 132.795 245.011",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1294 210.087C99.1294 210.087 86.286 210.856 80.3302 214.26",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.996 187.803C182.996 187.803 165.858 184.846 153.785 189.829C141.711 194.812 150.584 204.374 150.584 204.374C150.584 204.374 144.871 211.343 150.584 216.448C146.168 222.16 152.488 227.873 152.488 227.873C152.488 227.873 149.085 232.208 152.691 234.477C156.297 236.746 167.033 233.707 172.462 234.599C177.932 235.49 190.897 238.488 194.867 235.085",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M177.162 224.348C177.162 224.348 158.241 223.417 152.488 227.873",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M174.123 212.639C174.123 212.639 154.392 211.991 150.584 216.448",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 199.269C177.284 199.269 157.593 198.621 150.584 204.374",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M197.986 199.269C197.986 199.269 203.983 215.151 200.782 222.768",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M163.629 150.042V155.998",
    stroke: "#56183E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M167.723 150.042V155.998",
    stroke: "#56183E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M171.164 150.042V155.998",
    stroke: "#56183E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2015 64.4743L67.3654 58.8427C67.3654 58.8427 60.1942 74.198 69.5128 86.2311C69.0266 70.2275 70.2015 64.4743 70.2015 64.4743Z",
    fill: "url(#paint5_linear_388_1778)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.689 53.697C130.689 53.697 126.435 56.4926 120.074 51.6307C120.074 51.6307 128.623 52.8867 127.853 48.2274",
    fill: "url(#paint6_linear_388_1778)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M121.615 38.0176C121.615 38.0176 118.415 41.9476 110.879 39.2331C110.879 39.2331 119.387 37.8556 117.28 33.642",
    fill: "url(#paint7_linear_388_1778)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5977 37.8556C82.5977 37.8556 83.3675 39.3141 86.8113 40.1649C90.2146 41.0563 92.4024 39.0305 92.4024 39.0305C92.4024 39.0305 84.8665 37.0858 86.6087 33.642",
    fill: "url(#paint8_linear_388_1778)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M119.225 65.8511C115.781 60.1789 112.459 61.3944 101.034 60.7461C90.3378 60.1384 89.6085 53.4128 89.568 52.5215C89.6085 53.0887 89.8921 56.6541 93.0523 60.2194C96.4961 64.1089 104.194 64.0279 104.194 64.0279C102.371 64.352 100.345 64.6761 98.0357 65.0002C86.1241 66.7019 80.0469 55.0334 80.0469 55.0334C80.0469 55.0334 80.0468 57.5859 83.8553 62.6503C87.7042 67.7553 97.2254 67.7553 104.194 67.107C111.203 66.4588 115.66 68.363 117.888 74.7239C120.076 81.0848 116.916 85.5415 116.916 85.5415C121.129 82.5029 122.507 70.3077 119.225 65.8511Z",
    fill: "url(#paint9_linear_388_1778)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2168 115.402C43.2168 115.402 63.0288 114.106 70.5242 116.051C78.0195 117.955 81.7469 112.85 81.7469 112.85L77.4118 105.719C77.4118 105.719 76.2368 112.404 64.8115 110.946C53.3861 109.487 43.2168 115.402 43.2168 115.402Z",
    fill: "url(#paint10_linear_388_1778)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6552 161.792C33.6552 161.792 23.6074 144.006 25.4306 134.687C27.3348 124.923 38.7601 115.402 53.3862 119.211C67.9717 123.019 67.9717 123.019 67.9717 123.019C67.9717 123.019 53.6698 110.257 33.2095 116.334C12.7087 122.371 22.8781 153 33.0475 161.184",
    fill: "url(#paint11_linear_388_1778)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 91.0125C42.9316 91.0125 50.9942 85.5429 57.5982 89.0272C64.1617 92.5115 73.5613 98.2242 73.5613 98.2242L70.0365 89.5944C70.0365 89.5944 57.8818 76.8321 42.9316 91.0125Z",
    fill: "url(#paint12_linear_388_1778)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4551 22.5815C93.4551 22.5815 100.14 9.21141 104.394 10.832C108.648 12.4526 109.216 17.4765 116.225 14.3163C123.274 11.1967 128.339 4.22802 137.252 9.29244C146.166 14.3569 149.528 20.7178 149.528 20.7178C149.528 20.7178 151.23 10.5484 132.147 2.28328C121.37 -0.876925 116.265 6.73997 110.553 6.73997C104.84 6.73997 108.932 4.75471 106.866 4.4711C104.84 4.1875 94.1438 11.7234 93.4551 22.5815Z",
    fill: "url(#paint13_linear_388_1778)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3656 188.492C67.3656 188.492 58.6547 185.534 53.4688 186.345",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9219 159.563C41.9219 159.563 55.292 171.637 62.2606 177.512C69.2698 183.387 68.6215 187.195 68.6215 187.195L78.1832 175.77C78.1832 175.77 66.7578 157.578 60.0728 151.744C53.3878 145.91 41.9219 159.563 41.9219 159.563Z",
    fill: "#F8D3C9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9219 151.624C41.9219 151.624 58.047 177.715 76.0359 183.104C92.7687 159.24 98.4814 145.263 83.2476 133.189C71.3361 123.789 41.9219 151.624 41.9219 151.624Z",
    fill: "url(#paint14_linear_388_1778)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8633 135.74C90.8633 135.74 98.2371 153.81 112.985 151.42C127.732 149.07 139.806 125.085 139.806 125.085C139.806 125.085 129.799 146.072 113.511 145.018C97.2242 144.006 90.8633 135.74 90.8633 135.74Z",
    fill: "url(#paint15_linear_388_1778)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0452 182.739C80.0452 182.739 97.7504 205.468 112.457 203.077C127.205 200.727 132.796 193.556 132.796 193.556C132.796 193.556 126.84 197.77 110.553 196.716C94.266 195.703 80.0452 182.739 80.0452 182.739Z",
    fill: "url(#paint16_linear_388_1778)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8633 133.836C90.8633 133.836 95.482 146.072 113.511 145.019C131.541 144.006 139.806 124.275 139.806 124.275",
    stroke: "#350E28",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M134.702 246.307C134.702 246.307 135.998 263.446 95.3208 271.062C54.6434 278.72 48.2825 276.816 48.2825 276.816L29.2402 279.976C29.2402 279.976 82.599 267.538 101.965 261.987C121.372 256.477 134.702 246.307 134.702 246.307Z",
    fill: "url(#paint17_linear_388_1778)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M43.541 256.153L99.898 251.858L90.0932 246.632L43.541 256.153Z",
    fill: "url(#paint18_linear_388_1778)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M222.418 101.749C222.418 113.133 213.139 122.371 201.755 122.371C190.329 122.371 181.092 113.133 181.092 101.749C181.092 90.3233 190.329 81.0858 201.755 81.0858C213.139 81.0858 222.418 90.3233 222.418 101.749Z",
    fill: "url(#paint19_linear_388_1778)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5391 48.2278L47.6752 54.4672L53.4689 22.5815L27.5391 48.2278Z",
    fill: "url(#paint20_linear_388_1778)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M156.701 37.5722L161.077 31.2113L164.885 36.924L169.504 31.2113L173.15 36.924L176.959 31.2113L180.767 36.924L185.224 31.2113L189.681 36.924L193.611 31.2113",
    stroke: "#350E28",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M157.35 28.1317H194.219",
    stroke: "#F8D3C9",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3585 178.93H3.79688V169.409H13.3585V178.93Z",
    fill: "url(#paint21_linear_388_1778)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3585 193.557H3.79688V184.036H13.3585V193.557Z",
    stroke: "#350E28",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_1778",
    x1: 20.9674,
    y1: 0.860261,
    x2: 149.55,
    y2: 0.860261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_388_1778",
    x1: 152.344,
    y1: 102.188,
    x2: 174.17,
    y2: 225.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_388_1778",
    x1: 3.81025,
    y1: 233.034,
    x2: 142.759,
    y2: 233.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_388_1778",
    x1: 60.1401,
    y1: 28.1459,
    x2: 135.908,
    y2: 28.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_388_1778",
    x1: 144.244,
    y1: 122.359,
    x2: 194.417,
    y2: 122.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_388_1778",
    x1: -4.02173,
    y1: 68.1296,
    x2: 4.90346,
    y2: 37.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_388_1778",
    x1: 152.086,
    y1: 62.4268,
    x2: 78.5503,
    y2: 41.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_388_1778",
    x1: 160.099,
    y1: 52.9391,
    x2: 79.7154,
    y2: 30.5641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_388_1778",
    x1: 160.113,
    y1: 61.2512,
    x2: 83.3285,
    y2: 39.8782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_388_1778",
    x1: 111.65,
    y1: 51.0775,
    x2: 140.652,
    y2: 70.0793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_388_1778",
    x1: 43.2059,
    y1: 105.724,
    x2: 81.7648,
    y2: 105.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_388_1778",
    x1: 21.3353,
    y1: 114.69,
    x2: 67.9879,
    y2: 114.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_388_1778",
    x1: 42.9126,
    y1: 84.3165,
    x2: 73.5735,
    y2: 84.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_388_1778",
    x1: 93.4644,
    y1: 1.5151,
    x2: 149.578,
    y2: 1.5151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_388_1778",
    x1: 41.9365,
    y1: 131.255,
    x2: 92.1099,
    y2: 131.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_388_1778",
    x1: 125.312,
    y1: 141.577,
    x2: 118.73,
    y2: 165.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_388_1778",
    x1: 122.818,
    y1: 209.314,
    x2: 54.021,
    y2: 188.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_388_1778",
    x1: 65.352,
    y1: 251.958,
    x2: 108.97,
    y2: 229.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_388_1778",
    x1: 65.2796,
    y1: 249.48,
    x2: 87.0511,
    y2: 238.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_388_1778",
    x1: 181.097,
    y1: 81.083,
    x2: 222.401,
    y2: 81.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_388_1778",
    x1: 27.5504,
    y1: 22.5666,
    x2: 53.4762,
    y2: 22.5666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_388_1778",
    x1: 3.81025,
    y1: 169.409,
    x2: 13.3419,
    y2: 169.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaidAidMaps);
export default __webpack_public_path__ + "static/media/MaidAidMaps.2df8dd4a2db5978160fe7682f4d06442.svg";
export { ForwardRef as ReactComponent };